"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryWidgetAlertCountService = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var effects_1 = require("redux-saga/effects");
var general_1 = require("../events/general");
var layoutSelectors_1 = require("../store/layout/layoutSelectors");
var queryService_1 = require("../store/_infra/queryService");
var dashboardItemUtils_1 = require("../utils/dashboardItemUtils");
exports.QueryWidgetAlertCountService = queryService_1.createQueryService("GDC.DASH/QUERY.WIDGET.ALERT_COUNT", queryService);
function queryService(ctx, query) {
    var widgetRef, correlationId, widget, resultLoader, _a, result;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                widgetRef = query.payload.widgetRef, correlationId = query.correlationId;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetByRef(widgetRef))];
            case 1:
                widget = _b.sent();
                if (!widget) {
                    throw general_1.invalidQueryArguments(ctx, "Widget with ref " + sdk_model_1.objRefToString(widgetRef) + " does not exist on the dashboard", correlationId);
                }
                // just added KPIs with temporary identity cannot have alerts, do not try to load their count, it will fail
                if (!sdk_model_1.isKpiWidget(widget) || dashboardItemUtils_1.isTemporaryIdentity(widget)) {
                    return [2 /*return*/, 0];
                }
                resultLoader = ctx.backend.workspace(ctx.workspace).dashboards();
                return [4 /*yield*/, effects_1.call([resultLoader, resultLoader.getWidgetAlertsCountForWidgets], [widgetRef])];
            case 2:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), result = _a[0];
                return [2 /*return*/, result.alertCount];
        }
    });
}
//# sourceMappingURL=queryWidgetAlertCount.js.map